import { createSession } from '@entailor/auth-kit-browser/multi-org';

// The platform session for this page: AuthGuard boots it before the router mounts, and
// api.ts reads the org off it on every request.
const session = createSession({ storagePrefix: 'tailor' });

// Keys the hand-rolled store wrote before the kit owned it. Nothing reads them any more
// and they hold the org list with names and emails, so drop them on the way past.
try {
  localStorage.removeItem('tailor-sessions');
  localStorage.removeItem('tailor-last-active-org');
} catch {
  // Storage unavailable (private mode, blocked cookies) — nothing to clean up.
}

export default session;
